<template>
  <div>
    <user-form
      ref="form"
      :user="user"
      :alert-lists="alertLists"
      :all-alert-lists="allAlertLists"
      @save-success="saveComplete"
    />

    <save-bar
      class="mb-4"
      :show-delete="!$route.name.includes('create') && $login.can('users.delete')"
      @save="$refs.form.save()"
      @delete="$modal.show('confirm-delete')"
    />
    <confirm
      v-if="user"
      @confirmed="deleteUser"
      :name="user.name"
    />
  </div>
</template>

<script>
import UserForm from './Form'
import SaveBar from '@/components/SaveBar'
import {successNotification} from '@/notifications'
import Confirm from '@/components/Confirm'

export default {

  props: {
    user: {
      type: Object,
      required: true,
    },
    alertLists: {
      type: Array,
      required: true,
    },
    allAlertLists: {
      type: Array,
      required: true,
    },
  },

  components: {
    UserForm,
    SaveBar,
    Confirm,
  },

  methods: {
    deleteUser () {
      this.$http.delete(`users/${this.user.id}`)
          .then(() => {
            this.$notify(successNotification(`Deleted ${this.user.name}`))
            this.$router.go(-1)
          })
    },
    saveComplete (response) {
      this.$notify(successNotification(`Created ${response.data.data.first_name}`))
      if (this.$route.query.onComplete) {
        this.$router.replace({path: this.$route.query.onComplete})
      } else {
        this.$router.go(-1)
      }
    },
  },
}
</script>

